module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Daten Dossier Lohnabrechnungen-f8ff3ab5a0fe0dc459a24e4c8e38ef74.png";